

import { pdMixin } from '@/mixin/pd/pdMixin'
import SwiperWrap from '~/components/pd/common/SwiperCmp.vue'

export default {
  components: {
    SwiperWrap
  },
  mixins: [pdMixin],
  props: {
    pdNtfc: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    viewType: {
      type: String,
      default: ''
    },
    optionList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isOpt: {
      type: Boolean,
      default: false
    },
    bunPdList: { // 선택한 옵션 리스트(세트상품 리스트)
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    pdTy: {
      type: String,
      default: '01'
    }
  },
  data () {
    return {
      pdNtfcList: [], // 고시정보 리스트
      optPdNtfcList: [], // 옵션 고시정보 리스트
      orgPdNtfcList: [], // 고시정보 리스트
      bunPdNo: '', // 선택한 세트상품 번호
      optionSwipeOpt: {
        slidesPerView: 'auto',
        loop: false,
        lazy: true,
        auto: false,
        navigation: false,
        pagination: false
      },
      selectedOption: 0,
      selectedPdNo: '0'
    }
  },
  computed: {
    bundleType () {
      return this.viewType === 'bun' && this.bunPdList.length > 0
    }
  },
  mounted () {
    if (this.bundleType) { // 세트상품 일 경우
      this.orgPdNtfcList = this.pdNtfc.data
      this.bunPdNo = this.bunPdList[0].onldPdNo // 상품 옵션번호
      this.changeBunPd(this.bunPdNo)
    } else if (this.pdTy === '05') {
      this.optPdNtfcList = this.pdNtfc.data.filter(item => item.pdNo === this.optionList[0].pdNo)
    } else {
      this.pdNtfcList = this.pdNtfc.data
    }
  },
  methods: {
    changeBunPd (bunPdNo) {
      // 세트상품 선택 시 선택한 상품의 고시정보 노출
      const bunPd = this.bunPdList.filter(o => o.onldPdNo === bunPdNo)[0]
      this.pdNtfcList = this.orgPdNtfcList.filter(o => o.pdNo === bunPd.pdNo)
    },
    changeSelectOption (props) {
      this.optPdNtfcList = this.pdNtfc.data.filter(item => item.pdNo === props.item.pdNo)
      this.selectedOption = props.idx
    }
  }
}
